'use client';
import { SeriesSelectionBlock } from '~/app/_components/series-selection-block';
import { useLocalHooks } from './use-local-hooks';

type Props = {
  seriesId: string;
  ngKeywords: string[];
};

export const RecommendedSeriesFromSeriesBlock = ({
  seriesId,
  ngKeywords,
}: Props) => {
  const { seriesList, showLoading, showSensitive } = useLocalHooks(
    seriesId,
    ngKeywords
  );

  return (
    <SeriesSelectionBlock
      title="一緒に読まれている作品"
      series={seriesList}
      showLoading={showLoading}
      showSensitive={showSensitive}
    />
  );
};
